export default __webpack_public_path__ + "static/media/gallery_00.99d07ad3.jpg";